import React from 'react';
import EmbeddedAppFrame from 'app/components/EmbeddedAppFrame';
import { config } from '../../../../config/env';

/** Parâmetros extras do embed (ex.: `{ view: 'customer', external_id }`). `undefined` omite a chave. */
export type JusfyPayFrameParams = Record<string, string | undefined>;

/**
 * Protocolo de overlay do Pay (jusbank-front, `embedOverlay.ts` e `embedChrome.ts`):
 * o Pay avisa que abriu um drawer/modal e o host responde com a caixa do conteúdo.
 */
const PAY_OVERLAY = {
  stateMessage: 'PAY_OVERLAY_STATE',
  viewportMessage: 'PAY_HOST_VIEWPORT',
};

interface JusfyPayFrameProps {
  path?: string;
  newPaymentLink?: boolean;
  /** Parâmetros extras do embed; valem sobre a query da rota hospedeira. */
  params?: JusfyPayFrameParams;
  /** Altura do iframe; o padrão ocupa a viewport (páginas dedicadas). */
  height?: string;
  title?: string;
  /**
   * Expande o iframe quando o Pay avisa que abriu um drawer/modal. Só para telas
   * em que o iframe ocupa um pedaço da página (a aba Financeiro).
   */
  expandOnOverlay?: boolean;
}

const JusfyPayFrame: React.FC<JusfyPayFrameProps> = ({
  path = '/dashboard',
  newPaymentLink = false,
  params,
  height,
  title = 'Jusfy Pay',
  expandOnOverlay = false,
}) => {
  const extraParams: Record<string, string> = {};
  if (newPaymentLink) extraParams.newPaymentLink = 'true';
  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (value !== undefined) extraParams[key] = value;
  });

  return (
    <EmbeddedAppFrame
      baseUrl={config.jusfyPay.url}
      path={path}
      title={title}
      height={height}
      extraParams={Object.keys(extraParams).length ? extraParams : undefined}
      overlay={expandOnOverlay ? PAY_OVERLAY : undefined}
    />
  );
};

export default JusfyPayFrame;
